import posthog from 'posthog-js';
import { getI18nLanguageCode } from '../../../../../i18n';
import generalStore from '../../../../common/src/store/redux/store';
import { WgOAuth } from '../authentication/classes/WgAuthState';
import { getManifestFromQCache } from '../new-version/api/getManifest';
import API from './classes/API';

import { Middleware, wgApiClient as wgApiClientSDK } from 'wg-api-sdk';

export const wgApi = new API({
  baseURL: process.env.REACT_APP_API_HOST!,
  defaultHeadersFn: () => {
    return {
      'Accept-Language': getI18nLanguageCode(),
      'x-posthog': posthog.sessionRecordingStarted()
        ? posthog?.get_session_replay_url({ withTimestamp: true })
        : '',
      'x-logrocket':
        generalStore.getState().generalData.sessionRecordingUrl || '',
      'x-app-version': getManifestFromQCache()?.version || '',
      'x-app-module': window.location.pathname.split('/')?.[1] || '',
      'x-device-id': localStorage.getItem('wg-device-id') || '',
    };
  },
  oauthObject: WgOAuth,
});

export const wgApiSdk = wgApiClientSDK({
  baseUrl: process.env.REACT_APP_API_HOST!,
});

const wgApiAuthMiddleware: Middleware = {
  onRequest: ({ request }) => {
    const token = localStorage.getItem('wg-oauth-tokens') || '{}';
    const tokenObject = JSON.parse(token);
    if (tokenObject['accessToken']) {
      const defaultHeaders = {
        'Accept-Language': getI18nLanguageCode(),
        'x-posthog': posthog.sessionRecordingStarted()
          ? posthog?.get_session_replay_url({ withTimestamp: true })
          : '',
        'x-logrocket':
          generalStore.getState().generalData.sessionRecordingUrl || '',
        'x-app-version': getManifestFromQCache()?.version || '',
        'x-app-module': window.location.pathname.split('/')?.[1] || '',
        'x-device-id': localStorage.getItem('wg-device-id') || '',
        Authorization: `Bearer ${tokenObject['accessToken']}`,
      } as const;

      for (const [key, value] of Object.entries(defaultHeaders)) {
        request.headers.set(key, value);
      }
    }
  },
};

wgApiSdk.use(wgApiAuthMiddleware);
